/**
 * Object containing URLs for the VEF.
 * @memberof vef.defaults
 */
const URLS = {
    CDN: "https://cdn.awi.de/",
    BRAND: "https://cdn.awi.de/images/logos/marine_data.png"
};

export { URLS };